import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year5/Summer/PositionAndDirection/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'PositionAndDirection',
  field: 'Geometry',
  weeks: [4, 5],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/PositionAndDirection/1ReadAndPlotCoordinates" */ './1ReadAndPlotCoordinates'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/PositionAndDirection/2ProblemSolvingWithCoordinates" */ './2ProblemSolvingWithCoordinates'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/PositionAndDirection/3Translation" */ './3Translation'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/PositionAndDirection/4TranslationWithCoordinates" */ './4TranslationWithCoordinates'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/PositionAndDirection/5LinesOfSymmetry" */ './5LinesOfSymmetry'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/PositionAndDirection/6ReflectionInHorizontalAndVerticalLines" */ './6ReflectionInHorizontalAndVerticalLines'
        )
    })
  ]
});
export default Block;
